import { render } from "./SectionsProductsFriends.vue?vue&type=template&id=40723bf3&scoped=true"
import script from "./SectionsProductsFriends.vue?vue&type=script&lang=js"
export * from "./SectionsProductsFriends.vue?vue&type=script&lang=js"

import "./SectionsProductsFriends.vue?vue&type=style&index=0&id=40723bf3&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40723bf3"]])

export default __exports__